{
  "COMPOSE_REDIRECT": {
    "OPENING": "Tiek atvērta jauna saruna ar {email}…",
    "NO_EMAIL": "Nav norādīta e-pasta adrese. Izmantojiet ?email=name@example.com",
    "CONTACT_ERROR": "Neizdevās atrast kontaktpersonu, kas atbilst {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Lūdzu, izvēlieties sarunu kreisajā rūtī",
    "CSAT_REPLY_MESSAGE": "Lūdzu, novērtējiet sarunu",
    "404": "Atvainojiet, mēs nevaram atrast sarunu. Lūdzu mēģiniet vēlreiz",
    "SWITCH_VIEW_LAYOUT": "Pārslēgt izkārtojumu",
    "DASHBOARD_APP_TAB_MESSAGES": "Ziņojumi",
    "UNVERIFIED_SESSION": "Šā lietotāja identitāte nav pārbaudīta",
    "NO_MESSAGE_1": "Ak, vai! Izskatās, ka Jūsu iesūtnē nav ziņojumu no klientiem.",
    "NO_MESSAGE_2": " lai nosūtītu ziņojumu uz savu lapu!",
    "NO_INBOX_1": "Hola! Izskatās, ka jūs vēl neesat pievienojis nevienu iesūtni.",
    "NO_INBOX_2": " lai sāktu",
    "NO_INBOX_AGENT": "Ak, vai! Izskatās, ka Jūs neesat nevienas iesūtnes dalībnieks. Lūdzu, sazinieties ar savu administratoru",
    "SEARCH_MESSAGES": "Meklēt ziņojumus sarunās",
    "VIEW_ORIGINAL": "Skatīt oriģinālu",
    "VIEW_TRANSLATED": "Skatīt tulkoto",
    "TRANSLATION": "Tulkojums",
    "EMPTY_STATE": {
      "CMD_BAR": "lai atvērtu komandu izvēlni",
      "KEYBOARD_SHORTCUTS": "lai skatītu klaviatūras īsinājumtaustiņus"
    },
    "SEARCH": {
      "TITLE": "Meklēt ziņojumus",
      "RESULT_TITLE": "Meklēšanas Rezultāti",
      "LOADING_MESSAGE": "Tiek apkopoti dati...",
      "PLACEHOLDER": "Ievadiet jebkuru tekstu, lai meklētu ziņojumus",
      "NO_MATCHING_RESULTS": "Nav atrasts."
    },
    "UNREAD_MESSAGES": "Nelasītie ziņojumi",
    "UNREAD_MESSAGE": "Nelasīts ziņojums",
    "CLICK_HERE": "Noklikšķiniet šeit",
    "LOADING_INBOXES": "Notiek iesūtņu ielāde",
    "LOADING_CONVERSATIONS": "Notiek sarunu ielāde",
    "CANNOT_REPLY": "Jūs nevarat atbildēt, jo",
    "24_HOURS_WINDOW": "24 stundu ziņojuma loga ierobežojums",
    "NOT_ASSIGNED_TO_YOU": "Šī saruna nav Jums piešķirta. Vai vēlaties piešķirt šo sarunu sev?",
    "ASSIGN_TO_ME": "Piešķirt sev",
    "TWILIO_WHATSAPP_CAN_REPLY": "Jūs varat atbildēt uz šo sarunu, tikai izmantojot veidnes ziņojumu, jo",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 stundu ziņojuma loga ierobežojums",
    "REPLYING_TO": "Jūs atbildat uz:",
    "REMOVE_SELECTION": "Noņemt Izvēli",
    "DOWNLOAD": "Lejupielādēt",
    "UNKNOWN_FILE_TYPE": "Nezināms Fails",
    "SAVE_CONTACT": "Saglabāt Kontaktpersonu",
    "NO_CONTENT": "Nav satura, ko parādīt",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Pirms sūtīšanas veiciet:",
      "EXECUTE": "Izpildīt",
      "RETRY": "Mēģināt vēlreiz",
      "CONFIRM": "Izpildīt tagad?",
      "CONFIRM_YES": "Jā, izpildīt",
      "CONFIRM_NO": "Atcelt",
      "RUNNING": "Notiek izpilde…",
      "DONE": "Izpildīts",
      "CLAIM_DELAYED": "tiks iesniegta pēc pasūtījuma piegādes",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Izveidota JAUNA pretenzija {reference}, jo {planned} ir slēgta — labojiet melnraksta tekstu",
        "NEW_CLAIM": "Izveidota JAUNA pretenzija {reference}, nevis atjaunināta {planned} — labojiet melnraksta tekstu",
        "OTHER_CLAIM": "Atjaunināta pretenzija {reference} {planned} vietā — labojiet melnraksta tekstu",
        "EXISTING_CLAIM": "Jauna pretenzija neizveidota, atjaunināta esošā {reference} — labojiet melnraksta tekstu",
        "OTHER": "Notika citādi, nekā paredzēja melnraksts — labojiet melnraksta tekstu"
      },
      "FAILED": "Neizdevās",
      "UNREACHABLE": "Bots nav sasniedzams",
      "REQUEST_FAILED": "Darbību neizdevās sākt, lūdzu, mēģiniet vēlreiz.",
      "ACTIONS": {
        "CANCEL_ORDER": "Atceliet pasūtījumu",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Mainiet apmaksas veidu uz maksājumu piegādes brīdī",
        "CREATE_CLAIM": "Iesniedziet pretenziju",
        "CREATE_OR_UPDATE_CLAIM": "Iesniedziet vai atjauniniet pretenziju",
        "EXTEND_ORDER_PICKUP_DATE": "Pagariniet saņemšanas termiņu"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} kopīgoja kontaktpersonu",
      "LOCATION": "{sender} kopīgoja atrašanās vietu",
      "FILE": "{sender} kopīgoja failu"
    },
    "UPLOADING_ATTACHMENTS": "Notiek pielikumu augšupielāde...",
    "REPLIED_TO_STORY": "Atbildēja uz Jūsu stāstu",
    "UNSUPPORTED_MESSAGE": "Šis ziņojums netiek atbalstīts. Šo ziņojumu varat apskatīt Facebook/Instagram lietotnē.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Šis ziņojums netiek atbalstīts. Šo ziņojumu Jūs varat apskatīt lietotnē Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Šis ziņojums netiek atbalstīts. Šo ziņojumu Jūs varat apskatīt lietotnē Instagram.",
    "SUCCESS_DELETE_MESSAGE": "Ziņojums veiksmīgi izdzēsts",
    "FAIL_DELETE_MESSSAGE": "Nevarēja izdzēst ziņojumu! Mēģiniet vēlreiz",
    "NO_RESPONSE": "Nav atbildes",
    "RESPONSE": "Atbilde",
    "RATING_TITLE": "Vērtējums",
    "FEEDBACK_TITLE": "Atsauksmes",
    "REPLY_MESSAGE_NOT_FOUND": "Ziņa nav pieejama",
    "CARD": {
      "SHOW_LABELS": "Rādīt etiķetes",
      "HIDE_LABELS": "Slēpt etiķetes"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Atrisināt",
      "REOPEN_ACTION": "Atkārtoti atvērt",
      "OPEN_ACTION": "Atvērt",
      "OPEN": "Papildu",
      "CLOSE": "Aizvērt",
      "DETAILS": "detalizēta informācija",
      "SNOOZED_UNTIL": "Atlikts līdz",
      "SNOOZED_UNTIL_TOMORROW": "Atlikts līdz rītdienai",
      "SNOOZED_UNTIL_NEXT_WEEK": "Atlikts līdz nākamajai nedēļai",
      "SNOOZED_UNTIL_NEXT_REPLY": "Atlikts līdz nākamajai atbildei",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "nokavēti",
        "DUE": "jābeidz"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Atzīmēt kā neapstiprinātu",
      "SNOOZE_UNTIL": "Atlikt",
      "SNOOZE": {
        "TITLE": "Atlikt līdz",
        "NEXT_REPLY": "Nākamā atbilde",
        "TOMORROW": "Rītdiena",
        "NEXT_WEEK": "Nākamā nedēļa"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Atlikt līdz",
      "APPLY": "Atlikt",
      "CANCEL": "Atcelt"
    },
    "PRIORITY": {
      "TITLE": "Prioritāte",
      "OPTIONS": {
        "NONE": "Nav",
        "URGENT": "Steidzama",
        "HIGH": "Augsta",
        "MEDIUM": "Vidēja",
        "LOW": "Zema"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Nav",
        "INPUT_PLACEHOLDER": "Izvēlieties prioritāti",
        "NO_RESULTS": "Nav atrasts",
        "SUCCESSFUL": "Sarunas id {conversationId} prioritāte nomainīta uz {priority}",
        "FAILED": "Nevarēja nomainīt prioritāti. Lūdzu, mēģiniet vēlreiz."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Atvērt jaunā cilnē",
      "COPY_LINK": "Kopēt sarunas saiti",
      "COPY_LINK_SUCCESS": "Sarunas saite nokopēta starpliktuvē",
      "PENDING": "Atzīmēt kā neapstiprinātu",
      "RESOLVED": "Atzīmēt kā atrisinātu",
      "MARK_AS_UNREAD": "Atzīmēt kā nelasītu",
      "MARK_AS_READ": "Atzīmēt kā lasītu",
      "REOPEN": "Atkārtoti atvērt sarunu",
      "SNOOZE": {
        "TITLE": "Atlikt",
        "NEXT_REPLY": "Līdz nākamajai atbildei",
        "TOMORROW": "Līdz rītdienai",
        "NEXT_WEEK": "Līdz nākamajai nedēļai"
      },
      "ASSIGN_AGENT": "Piešķirt aģentu",
      "ASSIGN_LABEL": "Piešķirt etiķeti",
      "AGENTS_LOADING": "Notiek aģentu ielāde...",
      "ASSIGN_TEAM": "Piešķirt komandu",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Sarunas id {conversationId} piešķirts \"{agentName}\"",
          "FAILED": "Nevarēja piešķirt aģentu. Lūdzu, mēģiniet vēlreiz."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Sarunai ar id {conversationId} piešķirta etiķete #{labelName}",
          "FAILED": "Nevarēja piešķirt etiķeti. Lūdzu, mēģiniet vēlreiz."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Sarunai ar id {conversationId} tika piešķirta komanda \"{team}\"",
          "FAILED": "Nevarēja piešķirt komandu. Lūdzu, mēģiniet vēlreiz."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Ziņojuma paraksts",
      "ENABLE_SIGN_TOOLTIP": "Iespējot parakstu",
      "DISABLE_SIGN_TOOLTIP": "Atspējot parakstu",
      "MSG_INPUT": "Shift + Enter, lai pārietu uz jaunu rindu. Sāciet ar '/' lai izvēlētos sagatavotu atbildi.",
      "PRIVATE_MSG_INPUT": "Shift + Enter, lai pārietu uz jaunu rindu. Ziņojums būs redzams tikai Aģentiem",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Ziņojuma paraksts nav nokonfigurēts. Lūdzu, nokonfigurējiet to profila iestatījumos.",
      "CLICK_HERE": "Noklikšķiniet šeit, lai atjauninātu",
      "WHATSAPP_TEMPLATES": "WhatsApp Veidnes",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24 stundu WhatsApp periods ir beidzies. Atbildiet ar veidnes ziņojumu.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Šķiet, ka jūsu atbilde ir {draftLanguage} valodā, bet šī saruna ir {conversationLanguage} valodā.",
      "TRANSLATE_DRAFT": "Tulkot",
      "REPLY": "Atbildēt",
      "PRIVATE_NOTE": "Privāta Piezīme",
      "SEND": "Nosūtīt",
      "CREATE": "Pievienot Piezīmi",
      "INSERT_READ_MORE": "Lasīt vairāk",
      "DISMISS_REPLY": "Noraidīt atbildi",
      "REPLYING_TO": "Atbildot uz:",
      "TIP_FORMAT_ICON": "Rādīt bagātinātā teksta redaktoru",
      "HEADING_LEVEL": {
        "LABEL": "Teksta stils",
        "NORMAL": "Parasts teksts",
        "H1": "Virsraksts 1",
        "H2": "Virsraksts 2",
        "H3": "Virsraksts 3"
      },
      "EDITOR": {
        "BOLD": "Treknraksts",
        "ITALIC": "Slīpraksts",
        "UNDERLINE": "Pasvītrojums",
        "TEXT_COLOR": "Teksta krāsa",
        "BG_COLOR_LABEL": "Fona krāsa",
        "FONT_SIZE_LABEL": "Fonta izmērs",
        "FONT_SIZE": {
          "XS": "Mazs",
          "SM": "Vidēji mazs",
          "MD": "Noklusējuma",
          "LG": "Liels",
          "XL": "Ļoti liels",
          "XXL": "Milzīgs"
        },
        "CODE": "Kods",
        "LINK": "Pievienot vai noņemt saiti",
        "CREATE_LINK": "Izveidot saiti",
        "SAVE_LINK": "Saglabāt",
        "CANCEL": "Atcelt",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Atsaukt",
        "REDO": "Atkārtot",
        "BULLET_LIST": "Aizzīmju saraksts",
        "ORDERED_LIST": "Numurēts saraksts",
        "BLOCKQUOTE": "Citāts",
        "H1": "1. virsraksts",
        "H2": "2. virsraksts",
        "H3": "3. virsraksts",
        "IMAGE_UPLOAD": "Augšupielādēt attēlu",
        "CLEAR_FORMATTING": "Notīrīt formatējumu",
        "COLOR": {
          "RED": "Sarkans",
          "YELLOW": "Dzeltens",
          "BLUE": "Zils",
          "ROSE_RED": "Rožsarkans",
          "DEEP_CYAN": "Tumši ciāns",
          "ORANGE": "Oranžs",
          "PISTACHIO": "Pistācijzaļš",
          "PURPLE": "Violets",
          "FUCHSIA": "Fuksīns",
          "SILVER": "Sudrabains",
          "NAVY": "Tumši zils",
          "OLD_PINK": "Vecrozā",
          "AQUA": "Ūdenszils",
          "BROWN": "Brūns",
          "OLIVE": "Olīvzaļš",
          "GOLD": "Zeltains",
          "BEIGE": "Bēšs",
          "WINE": "Vīnsarkans",
          "FOREST": "Meža zaļš",
          "GREEN": "Zaļš",
          "BLUE_GREY": "Zilpelēks",
          "RUBY_RED": "Rubīnsarkans",
          "CHESTNUT_BROWN": "Kastaņbrūns",
          "ASH_GREY": "Pelnu pelēks"
        },
        "BG_COLOR": {
          "RED": "Sarkans",
          "YELLOW": "Dzeltens",
          "BLUE": "Zils",
          "ROSE_RED": "Rožsarkans",
          "DEEP_CYAN": "Tumši ciāns",
          "ORANGE": "Oranžs",
          "PISTACHIO": "Pistācijzaļš",
          "PURPLE": "Violets",
          "FUCHSIA": "Fuksīns",
          "SILVER": "Sudrabains",
          "NAVY": "Tumši zils",
          "OLD_PINK": "Vecrozā",
          "AQUA": "Ūdenszils",
          "BROWN": "Brūns",
          "OLIVE": "Olīvzaļš",
          "GOLD": "Zeltains",
          "BEIGE": "Bēšs",
          "WINE": "Vīnsarkans",
          "FOREST": "Meža zaļš",
          "GREEN": "Zaļš",
          "BLUE_GREY": "Zilpelēks",
          "RUBY_RED": "Rubīnsarkans",
          "CHESTNUT_BROWN": "Kastaņbrūns",
          "ASH_GREY": "Pelnu pelēks"
        }
      },
      "TIP_EMOJI_ICON": "Rādīt emocijzīmju atlasītāju",
      "TIP_ATTACH_ICON": "Pievienot failus",
      "TIP_AUDIORECORDER_ICON": "Ierakstīt audio",
      "TIP_AUDIORECORDER_PERMISSION": "Atļaut piekļuvi pie audio",
      "TIP_AUDIORECORDER_ERROR": "Nevarēja atvērt audio",
      "DRAG_DROP": "Velciet un nometiet šeit, lai pievienotu",
      "START_AUDIO_RECORDING": "Sākt audio ierakstīšanu",
      "STOP_AUDIO_RECORDING": "Apturēt audio ierakstīšanu",
      "": "",
      "EMAIL_HEAD": {
        "TO": "KAM",
        "ADD_BCC": "Pievienot bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "E-pasta adreses, atdalītas ar komatiem",
          "ERROR": "Lūdzu, ievadiet derīgas e-pasta adreses"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "E-pasta adreses, atdalītas ar komatiem",
          "ERROR": "Lūdzu, ievadiet derīgas e-pasta adreses"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Nedefinēti mainīgie",
        "MESSAGE": "Jūsu ziņojumā: {undefinedVariables} ir {undefinedVariablesCount} nedefinēti mainīgie. Vai tomēr vēlaties nosūtīt ziņojumu?",
        "CONFIRM": {
          "YES": "Nosūtīt",
          "CANCEL": "Atcelt"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Pievienojiet SMS iesūtni, lai sūtītu SMS atbildes.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Privāta Piezīme: Redzama tikai Jums un Jūsu komandai",
    "CHANGE_STATUS": "Sarunas statuss ir mainīts",
    "CHANGE_STATUS_FAILED": "Sarunas statusa maiņa neizdevās",
    "CHANGE_AGENT": "Mainīts sarunas Pilnvarotais",
    "CHANGE_AGENT_FAILED": "Pilnvarotā maiņa neizdevās",
    "ASSIGN_LABEL_SUCCESFUL": "Etiķete ir veiksmīgi piešķirta",
    "ASSIGN_LABEL_FAILED": "Etiķetes piešķiršana neizdevās",
    "CHANGE_TEAM": "Sarunu komanda mainīta",
    "FILE_SIZE_LIMIT": "Fails pārsniedz {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB pielikuma ierobežojumu",
    "MESSAGE_ERROR": "Nevar nosūtīt šo ziņojumu. Lūdzu, vēlāk mēģiniet vēlreiz",
    "SENT_BY": "Sūtīja:",
    "BOT": "Bot",
    "SEND_FAILED": "Nevarēja nosūtīt ziņojumu! Mēģiniet vēlreiz",
    "TRY_AGAIN": "mēģināt vēlreiz",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Izvēlieties Aģentu",
      "REMOVE": "Noņemt",
      "ASSIGN": "Piešķirt"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopēt",
      "REPLY_TO": "Atbildēt uz šo ziņojumu",
      "DELETE": "Dzēst",
      "CREATE_A_CANNED_RESPONSE": "Pievienot sagatavotajām atbildēm",
      "TRANSLATE": "Tulkot",
      "COPY_PERMALINK": "Kopēt saiti uz ziņojumu",
      "LINK_COPIED": "Ziņojuma URL ir iekopēts starpliktuvē",
      "DELETE_CONFIRMATION": {
        "TITLE": "Vai tiešām vēlaties dzēst šo ziņojumu?",
        "MESSAGE": "Šo darbību nevar atsaukt",
        "DELETE": "Dzēst",
        "CANCEL": "Atcelt"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Kontaktpersona",
      "COPILOT": "Kopilots"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "{userName} sarunu atzīmēja kā atrisinātu",
          "CONTACT_RESOLVED": "{contactName} atrisināja sarunu",
          "OPEN": "{userName} atkārtoti atvēra sarunu",
          "PENDING": "{userName} sarunu atzīmēja kā neapstiprinātu",
          "SNOOZED": "{userName} atlika sarunu",
          "AUTO_RESOLVED": "Sistēma sarunu atzīmēja kā atrisinātu {duration} dienu neaktivitātes dēļ",
          "SYSTEM_AUTO_OPEN": "Sistēma atkārtoti atvēra sarunu jauna ienākoša ziņojuma dēļ.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Sistēma atzīmēja sarunu kā atrisinātu, jo pieteikums tika slēgts platformā Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} iestatīja prioritāti uz {newPriority}",
          "UPDATED": "{userName} nomainīja prioritāti no {oldPriority} uz {newPriority}",
          "REMOVED": "{userName} noņēma prioritāti"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} sev piešķīra šo sarunu",
          "ASSIGNED": "{userName} piešķīra sarunu {assigneeName}",
          "REMOVED": "{userName} noņēma piešķiršanu"
        },
        "TEAM": {
          "ASSIGNED": "{userName} piešķīra sarunu {teamName}",
          "ASSIGNED_WITH_ASSIGNEE": "{userName} caur {teamName} piešķīra sarunu {assigneeName}",
          "REMOVED": "{userName} noņēma piešķiršanu {teamName}"
        },
        "LABELS": {
          "ADDED": "{userName} pievienoja {labels}",
          "REMOVED": "{userName} noņēma {labels}"
        },
        "SLA": {
          "ADDED": "{userName} pievienoja SLA politiku {slaName}",
          "REMOVED": "{userName} noņēma SLA politiku {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} izslēdza sarunu",
        "UNMUTED": "{userName} ieslēdza sarunu",
        "CONTACT_BLOCKED": "{userName} bloķēja kontaktpersonu",
        "CONTACT_UNBLOCKED": "{userName} atbloķēja kontaktpersonu",
        "AUTO_RESOLUTION_MESSAGE": "Saruna tiek pabeigta, jo tā kādu laiku ir bijusi neaktīva. Ja nepieciešama papildu palīdzība, lūdzu, sāciet jaunu sarunu.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Pārvietots, jo kontakta pasūtījumi ir tikai no veikala {storeName} (pēdējais pasūtījums {orderId}), kura robots atbild šajā iesūtnē.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatizācija tika izlaista, jo kontakts ir bloķēts",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatizācija \"{ruleName}\" nevarēja pārvietot šo sarunu no iesūtnes {sourceInboxName} uz iesūtni {targetInboxName}, jo iesūtnes nav saderīgas.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatizācija \"{ruleName}\" nevarēja pārvietot šo sarunu no iesūtnes {sourceInboxName} uz iesūtni {targetInboxName}, jo kontaktam nav e-pasta adreses.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatizācija „{ruleName}“ nevarēja nosūtīt ziņojumu: šī tālruņa iesūtne nevar sūtīt SMS, jo kontam nav SMS iesūtnes. Noteikums tika izslēgts, un administratori saņēma e-pastu.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatizācija „{ruleName}“ nevarēja nosūtīt ziņojumu: no šīs iesūtnes pielikumus nevar nosūtīt ar SMS. Noteikums tika izslēgts, un administratori saņēma e-pastu.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makro „{macroName}“ nenosūtīja ziņojumu: šī tālruņa iesūtne nevar sūtīt SMS, jo kontam nav SMS iesūtnes.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makro „{macroName}“ nenosūtīja ziņojumu: no šīs iesūtnes pielikumus nevar nosūtīt ar SMS.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makro „{macroName}“ nenosūtīja ziņojumu: šo sarunu apstrādā bots. Vispirms atveriet sarunu.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makro „{macroName}“ nenosūtīja ziņojumu: šī iesūtne ir atzīmēta dzēšanai. Vispirms pārvietojiet sarunu uz citu iesūtni.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatizācija \"{ruleName}\" nosūtīja e-pastu uz {contactEmail} jaunā sarunā [#{conversationId}]({conversationPath}) iesūtnē {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatizācija \"{ruleName}\" sāka šo sarunu iesūtnes {inboxName} sarunas [#{conversationId}]({conversationPath}) dēļ.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatizācija \"{ruleName}\" nevarēja nosūtīt ziņojumu jaunā sarunā iesūtnē {inboxName}, jo kontaktam nav e-pasta adreses.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatizācija \"{ruleName}\" nosūtīja SMS uz {contactPhone} jaunā sarunā [#{conversationId}]({conversationPath}) iesūtnē {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatizācija \"{ruleName}\" nevarēja nosūtīt SMS jaunā sarunā iesūtnē {inboxName}, jo kontaktam nav tālruņa numura.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Aģents",
            "CUSTOMER": "Klients"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "atbildēts citur, zvanīja {duration}",
            "NO_ANSWER": "neatbildēts, zvanīja {duration}",
            "REJECTED": "noraidīts, zvanīja {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Automātiski atrisināts pēc neveiksmīgu atzvanu skaita: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Zvana ierakstu dzēsis {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Klientam neredzams",
    "SENT_VIA_EMAIL": "Kontaktpersonai nosūtīts arī pa e-pastu ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Šī iesūtne ir atzīmēta dzēšanai, tāpēc klienta atbilde nekad nenonāks. Lai atbildētu, pārvietojiet sarunu uz citu iesūtni.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Šim kontaktam ir vēl viena atvērta saruna #{id}",
      "MULTIPLE": "Šim kontaktam ir citas atvērtas sarunas ({count})",
      "OPEN": "Atvērt",
      "SHOW": "Rādīt"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Lūgt klientam kopīgot savu WhatsApp tālruņa numuru",
      "PENDING_ACTION": "Kontaktinformācijas pieprasījums gaida atbildi",
      "STATES": {
        "PENDING": "Gaida kontaktinformāciju",
        "SHARED": "Tālruņa numurs kopīgots",
        "IDENTITY_CONFLICT": "Tālruņa numurs jāpārbauda"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Nosūtīt sarunas transkriptu",
    "DESC": "Nosūtīt sarunas transkripta kopiju uz norādīto e-pasta adresi",
    "SUBMIT": "Iesniegt",
    "CANCEL": "Atcelt",
    "SEND_EMAIL_SUCCESS": "Sarunas transkripts tika veiksmīgi nosūtīts",
    "SEND_EMAIL_ERROR": "Radās kļūda. Lūdzu, mēģiniet vēlreiz",
    "FORM": {
      "SEND_TO_CONTACT": "Nosūtīt transkriptu klientam",
      "SEND_TO_AGENT": "Nosūtīt transkriptu piešķirtajam aģentam",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Nosūtīt transkriptu uz citu e-pasta adresi",
      "EMAIL": {
        "PLACEHOLDER": "Ievadiet e-pasta adresi",
        "ERROR": "Lūdzu ievadiet derīgu e-pasta adresi"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Sveicināti 👋, Laipni lūdzam {installationName}!",
    "DESCRIPTION": "Paldies, ka reģistrējāties. Mēs vēlamies, lai Jūs gūtu maksimālu labumu no {installationName}. Šeit ir dažas lietas, ko varat darīt {installationName} lai Jūsu pieredze būtu patīkamāka.",
    "GREETING_MORNING": "👋 Labrīt, {name}. Laipni lūdzam {installationName}.",
    "GREETING_AFTERNOON": "👋 Labdien, {name}. Laipni lūdzam {installationName}.",
    "GREETING_EVENING": "👋 Labvakar, {name}. Laipni lūdzam {installationName}.",
    "READ_LATEST_UPDATES": "Izlasīt mūsu aktuālākos jaunumus",
    "ALL_CONVERSATION": {
      "TITLE": "Visas Jūsu sarunas vienuviet",
      "DESCRIPTION": "Skatīt visas sarunas ar klientiem vienā informācijas panelī. Jūs varat filtrēt sarunas pēc ienākošā kanāla, etiķetes un statusa.",
      "NEW_LINK": "Noklikšķiniet šeit, lai izveidotu iesūtni"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Uzaicināt savas komandas biedrus",
      "DESCRIPTION": "Tā kā Jūs gatavojaties runāt ar savu klientu, piesaistiet savus komandas biedrus, lai viņi Jums palīdzētu. Jūs varat uzaicināt savus komandas biedrus, pievienojot viņu e-pasta adreses aģentu sarakstam.",
      "NEW_LINK": "Noklikšķiniet šeit, lai uzaicinātu komandas biedru"
    },
    "LABELS": {
      "TITLE": "Organizēt sarunas ar etiķetēm",
      "DESCRIPTION": "Etiķetes nodrošina vienkāršāku veidu, kā klasificēt sarunu. Izveidojiet dažas etiķetes, piemēram, #atbalsta-pieprasījums, #norēķinu-jautājums utt., lai vēlāk varētu tās izmantot sarunas laikā.",
      "NEW_LINK": "Noklikšķiniet šeit, lai izveidotu atzīmes"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Izveidot sagatavotas atbildes",
      "DESCRIPTION": "Iepriekš sagatavotas atbildes veidnes palīdz ātri reaģēt uz sarunu. Aģenti var izmantot '/' rakstzīmi, kurai seko kods, lai ievietotu atbildi.",
      "NEW_LINK": "Noklikšķiniet šeit, lai izveidotu sagatavotu atbildi"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Piešķirts Aģentam",
    "SELF_ASSIGN": "Piešķirts man",
    "TEAM_LABEL": "Piešķirtā Komanda",
    "SELECT": {
      "PLACEHOLDER": "Nav"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Kontaktpersonas Informācija",
      "CONVERSATION_ACTIONS": "Sarunas Darbības",
      "CONVERSATION_LABELS": "Sarunu Etiķetes",
      "CONVERSATION_INFO": "Sarunas Informācija",
      "CONTACT_ATTRIBUTES": "Kontaktpersonas Īpašības",
      "PREVIOUS_CONVERSATION": "Iepriekšējās Sarunas",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Gaida",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Izveidot Īpašību",
    "NO_RECORDS_FOUND": "Īpašības nav atrastas",
    "UPDATE": {
      "SUCCESS": "Īpašība ir veiksmīgi atjaunināta",
      "ERROR": "Nevar atjaunināt īpašību. Lūdzu, pamēģiniet vēlāk vēlreiz"
    },
    "ADD": {
      "TITLE": "Pievienot",
      "SUCCESS": "Īpašība ir veiksmīgi pievienota",
      "ERROR": "Nevar pievienot īpašību. Lūdzu, pamēģiniet vēlāk vēlreiz"
    },
    "DELETE": {
      "SUCCESS": "Īpašība ir veiksmīgi izdzēsta",
      "ERROR": "Nevar izdzēst īpašību. Lūdzu, pamēģiniet vēlāk vēlreiz"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Pievienot īpašības",
      "PLACEHOLDER": "Meklēt īpašības",
      "NO_RESULT": "Īpašības nav atrastas"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "No",
    "TO": "Kam",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Tēma"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Piedalās",
    "SIDEBAR_TITLE": "Sarunas dalībnieki",
    "NO_RECORDS_FOUND": "Nav atrasts",
    "ADD_PARTICIPANTS": "Izvēlieties dalībniekus",
    "REMANING_PARTICIPANTS_TEXT": "+{count} citi",
    "REMANING_PARTICIPANT_TEXT": "+{count} cits",
    "TOTAL_PARTICIPANTS_TEXT": "{count} cilvēki piedalās.",
    "TOTAL_PARTICIPANT_TEXT": "{count} persona piedalās.",
    "NO_PARTICIPANTS_TEXT": "Neviens nepiedalās!",
    "WATCH_CONVERSATION": "Pievienoties sarunai",
    "YOU_ARE_WATCHING": "Jūs piedalāties",
    "API": {
      "ERROR_MESSAGE": "Nevarēja atjaunināt, mēģiniet vēlreiz!",
      "SUCCESS_MESSAGE": "Dalībnieki atjaunināti!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Skatīt tulkoto saturu",
    "DESC": "Jūs varat skatīt tulkoto saturu katrā valodā.",
    "ORIGINAL_CONTENT": "Oriģinālais Saturs",
    "TRANSLATED_CONTENT": "Tulkotais Saturs",
    "NO_TRANSLATIONS_AVAILABLE": "Šim saturam nav pieejami tulkojumi"
  },
  "TYPING": {
    "ONE": "{user} raksta",
    "TWO": "{user} un {secondUser} raksta",
    "MULTIPLE": "{user} un {count} citi raksta",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Pamēģiniet"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Nevar lejupielādēt pielikumu. Lūdzu, mēģiniet vēlreiz"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Pasūtījuma numurs",
    "EXTERNAL_ID": "Ārējais ID",
    "PAYMENT_TYPE": "Maksājuma veids",
    "PAYMENT_DATE": "Maksājuma datums",
    "DELIVERY_PROVIDER": "Piegādātājs",
    "EXPECTED_DATE_OF_DELIVERY": "Paredzamā piegāde",
    "DATE_OF_DELIVERY": "Piegādāts",
    "EXPEDITION_DATE": "Nosūtīšanas datums",
    "INTERNAL_NOTE": "Veikala piezīme",
    "PACKAGE_NUMBER": "Sūtījums"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
